import { render, staticRenderFns } from "./ViewMethodContributions.vue?vue&type=template&id=d45b585a"
import script from "./ViewMethodContributions.vue?vue&type=script&lang=js"
export * from "./ViewMethodContributions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports